import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { OrderMetadata, OrderStatus, OrderType } from '../../order-v2.types';
import { ClipboardService } from '../../../../../core/services/clipboard/clipboard.service';

@Component({
  selector: 'app-order-v2-header',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './order-header.component.html',
  styleUrl: './order-header.component.scss',
})
export class OrderHeaderComponent {
  @Input({ required: true }) orderId!: string;
  @Input() groupOrderIds: string[] = [];
  @Input({ required: true }) orderType!: OrderType;
  @Input({ required: true }) status!: OrderStatus;
  @Input({ required: true }) statusLabel!: string;
  @Input({ required: true }) createdAt!: string;
  @Input({ required: true }) metadata!: OrderMetadata;
  @Input({ required: true }) deliveryType!: string;
  @Input({ required: true }) deliveryDate!: string;
  @Input() alertCount = 0;
  @Input() invoiceNumber: string | null = null;

  private readonly _clipboard = inject(ClipboardService);

  get statusBadgeClass(): string {
    const s = (this.status ?? '').toLowerCase();
    if (s === 'invoiced') {
      return 'border-green-200 bg-green-50 text-green-700 dark:border-green-900/50 dark:bg-green-900/20 dark:text-green-400';
    }
    if (s.includes('cancel')) {
      return 'border-red-200 bg-red-50 text-red-700 dark:border-red-900/50 dark:bg-red-900/20 dark:text-red-400';
    }
    return 'border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-900/50 dark:bg-amber-900/20 dark:text-amber-400';
  }

  copyBadge(value: string | null | undefined): void {
    if (value === null || value === undefined) return;
    this._clipboard.copy(String(value));
  }
}
